import { BlEntityDefinition } from '@blcloud/bl-datamodel/core/bl-entity-definition';
import { Injectable } from '@angular/core';
import { BlApiClient, BlResource } from '@blcloud/bl-ng-common';

/**
 * 論理データモデル『受注メモ』の定義情報クラス
 */
export class OrdermemoDef extends BlEntityDefinition {
  /** サブドメイン */
  static readonly SUBDOMAIN: string = 'sales';

  /** エンドポイント */
  static readonly END_POINT = 'ordermemo';

  /** IDとして使用されるプロパティ名配列 */
  static readonly keyProperties: string[] = [];
}

/**
 * 『受注メモ』リソースクラス
 */
@Injectable()
export class OrdermemoResource extends BlResource {
  /**
   * エンティティ定義情報
   */
  entityDefinition = OrdermemoDef;

  constructor(protected apiClient: BlApiClient) {
    super(apiClient);
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page.define.ts